var _rect, _rect2, _path, _path2, _path3, _circle, _path4, _circle2, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _circle3, _circle4, _circle5, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 194,
    viewBox: "0 0 291 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.3672,
    y: 42.7344,
    width: 244.268,
    height: 130.709,
    rx: 16.2169,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0546875,
    y: 109.627,
    width: 290.892,
    height: 84.3652,
    rx: 16.2169,
    fill: "#29315D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.2891 140.916C92.2891 137.066 95.41 133.945 99.2598 133.945L228.706 133.945C232.556 133.945 235.677 137.066 235.677 140.916C235.677 144.766 232.556 147.886 228.706 147.886H99.2598C95.4099 147.886 92.2891 144.766 92.2891 140.916Z",
    fill: "#434A70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2891 163.152C92.2891 159.302 95.41 156.181 99.2598 156.181L153.135 156.181C156.985 156.181 160.106 159.302 160.106 163.152C160.106 167.002 156.985 170.123 153.135 170.123H99.2598C95.41 170.123 92.2891 167.002 92.2891 163.152Z",
    fill: "#434A70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169 163.152C169 159.302 172.121 156.181 175.971 156.181L183.709 156.181C187.558 156.181 190.679 159.302 190.679 163.152C190.679 167.002 187.558 170.123 183.709 170.123H175.971C172.121 170.123 169 167.002 169 163.152Z",
    fill: "#434A70"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.8658,
    cy: 152.024,
    r: 26.1783,
    fill: "#3158F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6357 147.115L45.7036 156.047L40.3438 150.687",
    stroke: "white",
    strokeWidth: 4.90844,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.326,
    cy: 40.9135,
    r: 40.7475,
    fill: "#3158F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.242 60.6157C152.488 60.6163 159.155 56.6553 162.62 50.291",
    stroke: "white",
    strokeWidth: 3.70793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.026 40.8327C165.026 29.9064 156.169 21.0488 145.242 21.0488",
    stroke: "white",
    strokeWidth: 3.70793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M145.245 21.0488C137.999 21.0482 131.332 25.0092 127.867 31.3735",
    stroke: "white",
    strokeWidth: 3.70793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125.461 40.832C125.461 51.7584 134.318 60.6159 145.245 60.6159",
    stroke: "white",
    strokeWidth: 3.70793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.867 31.3706C132.192 23.4232 141.357 19.4224 150.125 21.6542C158.893 23.8861 165.03 31.782 165.029 40.8298",
    stroke: "white",
    strokeWidth: 3.70793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M125.461 40.832C125.46 49.8799 131.596 57.7757 140.365 60.0076C149.133 62.2395 158.298 58.2386 162.622 50.2912",
    stroke: "white",
    strokeWidth: 3.70793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M135.469 31.3714H126.727V22.627",
    stroke: "white",
    strokeWidth: 3.70793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M155.016 50.291H163.758V59.0355",
    stroke: "white",
    strokeWidth: 3.70793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.6346,
    cy: 59.9998,
    r: 5.10336,
    fill: "#EAEAEF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.0067,
    cy: 59.9998,
    r: 5.10336,
    fill: "#EAEAEF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.3788,
    cy: 59.9998,
    r: 5.10336,
    fill: "#EAEAEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 226.695,
    y: 54.8965,
    width: 28.5788,
    height: 11.2274,
    rx: 4.08269,
    fill: "#EAEAEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalBanner);
export default __webpack_public_path__ + "static/media/modal-banner.64692998cd956506830d3f7c70fbac55.svg";
export { ForwardRef as ReactComponent };